import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccountBundleSelectionComponent } from './components/account-bundle-selection/account-bundle-selection.component';
// import { EnrollmentVerificationComponent } from './components/enrollment-verification/enrollment-verification.component';
import { NotificationPreferencesComponent } from './components/notification-preferences/notification-preferences.component';
// import { NotificationHistoryComponent } from './components/notification-history/notification-history.component';
// import { MessagePageComponent } from './components/body-sections/message-page/message-page.component';
import { AccountTasksComponent } from './components/account-tasks/account-tasks.component';
import { PaymentDemoComponent } from './components/payment-demo/payment-demo.component';
import { PageDispatcherComponent } from './components/page-dispatcher/page-dispatcher.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';

const routes: Routes = 
[
  { path: '', redirectTo: 'home', pathMatch: 'full' }, 
  { path: 'acct-bundle', component: AccountBundleSelectionComponent }, 
  // { path: 'ev-page', component: EnrollmentVerificationComponent }, 
  { path: 'notif-prefs', component: NotificationPreferencesComponent }, 
  // { path: 'notif-log', component: NotificationHistoryComponent }, 
  // { path: 'msg-page', component: MessagePageComponent },
  { path: 'acct-tsk', component: AccountTasksComponent }, 
  { path: 'pmt-demo', component: PaymentDemoComponent }, 
  { path: 'pg-disp', component: PageDispatcherComponent }, 
  // { path: 'pg-disp', loadComponent: () => import('./components/page-dispatcher/page-dispatcher.component').then(mod => mod.PageDispatcherComponent)},
  { path: 'err', component: ErrorPageComponent }, 
    { path: 'pswd-reset', component: PasswordResetComponent },

  { path: '**', pathMatch: 'full', component: ErrorPageComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
